import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import InNhanVay from "../../../../containers/NhanVay/InNhanVay";
import { pushNotification } from "utils/notifications";
import { useSelector, useDispatch } from "react-redux";
export const BtnInHopDong = ({ choVay }) => {
  const listNhanVay = useSelector((state) => state.listNhanVay);
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [isModalVisible, setModalVisible] = useState(false);
  const toggleModal = () => {
    if (choVay && !choVay.ID) {
      pushNotification("Hãy chọn hợp đồng", "warning", "TOP_CENTER", 1000);
      return;
    }

    setModalVisible(!isModalVisible);
  };

  return (
    <>
      <a
        href={() => false}
        className="icon-bgnew color-print1"
        onClick={toggleModal}
      >
        <PopoversBootrap
          contentText="In hợp đồng"
          titleText=""
          trigger={["hover", "focus"]}
          placement={"top"}
        >
          <i className="mdi mdi-printer"></i>
        </PopoversBootrap>
      </a>
      {isModalVisible && (
        <InNhanVay show={isModalVisible} onHide={toggleModal} data={choVay} />
      )}
    </>
  );
};
